import { render, staticRenderFns } from "./cargoOwnerAction.vue?vue&type=template&id=4d1ebd4c"
import script from "./cargoOwnerAction.vue?vue&type=script&lang=js"
export * from "./cargoOwnerAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports